import type Quill from 'quill/core';
import type { DraggableBlot } from './ReorderGutterButton';

function getNumericalComputedStyle(
  domNode: Element | null,
  property: 'marginBottom' | 'marginTop',
) {
  if (!domNode) return 0;
  const style = getComputedStyle(domNode);
  const value = style[property];
  return value ? parseInt(value, 10) : 0;
}

const getDropPlaceholderPosition = (quill: Quill, blot: DraggableBlot) => {
  const { domNode } = blot;
  const { bottom, left, right } = domNode.getBoundingClientRect();
  const {
    top,
    left: containerLeft,
    right: containerRight,
  } = quill.container.getBoundingClientRect();

  const marginBottom = getNumericalComputedStyle(domNode, 'marginBottom');
  const marginTop = getNumericalComputedStyle(
    domNode.nextElementSibling,
    'marginTop',
  );
  const collapsedMargin = Math.max(marginBottom, marginTop);

  return {
    top: `${bottom - top + collapsedMargin / 2}px`,
    left: `${left - containerLeft}px`,
    right: `${containerRight - right}px`,
    transform: 'translateY(-50%)',
  };
};

export default getDropPlaceholderPosition;
